<script>
import { Place } from '@/api'
import fields from '@/components/fields/'
import FormMixin from '@/crudBases/form/FormMixin'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Place List' }
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          required: true,
          modelPath: [this, 'form', 'name'],
          multilingual: true
        })
      ]
    }
  },
  computed: {
    service() {
      return Place
    }
  }
}
</script>
